import { PAGE_SETTINGS_DEFAULT_STATE } from 'helpers/constants/store';

export default class SharedState {
  constructor() {
    // CREATE
    this.uploadFile = {
      loading: {},
      data: {},
      error: {},
    };
    this.uploadMultipleFile = {
      loading: {},
      data: {},
      error: {},
    };
    this.pageSettings = {
      ...PAGE_SETTINGS_DEFAULT_STATE,
    };
  }
}
